import { getFlexibleExperiences, getInstalledExperiencesForDevice } from "../api/graphql/experiences";

export const getExperiencesForDevice = async (xcubeId) => {
    let experiences = [];
    const flexibleExps = await getFlexibleExperiences();
    if (xcubeId) {
        const result = await getInstalledExperiencesForDevice(xcubeId);
        experiences = result.flatMap((item) => item.application.experiences);
    }
    experiences.push(...flexibleExps);
    experiences = experiences.filter((exp, index, self) =>
        index === self.findIndex((e) => e.id === exp.id)
    );
    experiences.sort((a, b) => a.name.localeCompare(b.name));
    return experiences;
}